import { useLearningObjectSEO } from '@hendrx/core/common/hooks/learningObject/useLearningObjectSEO';
import { AssignmentAuthorization } from '@hendrx/core/learningActivity/components/AssignmentAuthorization';
import { LearningActivityAssignmentSetup } from '@hendrx/core/learningActivity/components/LearningActivityAssignmentSetup';
import { LearningActivityPlayerContent } from '@hendrx/core/learningActivity/components/LearningActivityPlayerContent';
import { createFileRoute } from '@tanstack/react-router';

import { useFetchSnapshotForAssignment } from 'shared/queries/snapshot';

import { createRouteGuard } from '@/app/_lib/guards/createRouteGuard';
import { requireAuthenticated } from '@/app/_lib/guards/primitives';

export const Route = createFileRoute('/player/assignment/$assignmentId')({
  beforeLoad: createRouteGuard(requireAuthenticated()),
  validateSearch: (search: Record<string, unknown>) => {
    return {
      page: (search.page as string | undefined) || undefined,
      studentId: (search.studentId as string | undefined) || undefined
    };
  },
  component: PlayerAssignmentPage
});

function PlayerAssignmentPage() {
  const { assignmentId } = Route.useParams();

  const { data: snapshot } = useFetchSnapshotForAssignment({ assignmentId });

  useLearningObjectSEO({ title: snapshot?.metadata.title, description: snapshot?.metadata?.description });

  return (
    <AssignmentAuthorization assignmentId={assignmentId}>
      <LearningActivityAssignmentSetup assignmentId={assignmentId}>
        {props => (
          <LearningActivityPlayerContent
            learningObjectSnapshotExists={props.snapshotExists}
            isLearningObjectSnapshotError={props.isError}
          />
        )}
      </LearningActivityAssignmentSetup>
    </AssignmentAuthorization>
  );
}
